import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The four-point sparkle that marks assistant surfaces ("Ask Panorama",
 * "Panorama AI").
 *
 * Inlined rather than taken from RDS because RDS 4.21.1 ships no sparkle — all
 * 516 icons in `@rds/core` were checked, and `chat_recommendation` (what the
 * header's Panorama AI button uses) is a speech bubble, not the mark the design
 * calls for. Inline keeps it colourable via `currentColor` and costs no request.
 */
@Component({
  selector: 'inexp-sparkle-icon',
  template: `
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="currentColor"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M12 2.5l1.9 5.3a4 4 0 002.3 2.3l5.3 1.9-5.3 1.9a4 4 0 00-2.3 2.3L12 21.5l-1.9-5.3a4 4 0 00-2.3-2.3L2.5 12l5.3-1.9a4 4 0 002.3-2.3L12 2.5z"
      />
      <path d="M19 2.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2z" />
    </svg>
  `,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      line-height: 0;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SparkleIconComponent {}
